import { createContext, useCallback, useState } from 'react';

export interface UserContextInterface {
  email: string;
  firstName: string;
  lastName: string;
  role: number;
  avatar: string;
  regionId: string;
  marketAccess: string;
}

const DEFAULT_USER: UserContextInterface | null = null;
interface DefaultContextUser {
  user: UserContextInterface | null;
  updateUser: (data: any) => void;
}

const DEFAULT_CONTEXT: DefaultContextUser = {
  user: DEFAULT_USER,
  updateUser: (data: any) => {},
};

export const UserContext = createContext(DEFAULT_CONTEXT);

export function useUserContext(): DefaultContextUser {
  const [user, setUser] = useState(DEFAULT_USER);
  const updateUser = useCallback((data): void => {
    setUser(data);
  }, []);

  return {
    user,
    updateUser,
  };
}
